export class ModelAudit{
    fieldNames: any;
    oldValues: any;
    newValues: any;
    role: any;
}